define("media/components/media/table/sortable-columns", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _computed, _service, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _trackMediaSort;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{yield
    (hash
      th=(component "media/table/sortable-header-cell" sortDefinition=this.sortDefinition toggleSort=this.toggleSort)
      sortedItems=this.sortedItems
    )
  }}
  */
  {
    "id": "HmbZW1vQ",
    "block": "[[[18,1,[[28,[37,1],null,[[\"th\",\"sortedItems\"],[[50,\"media/table/sortable-header-cell\",0,null,[[\"sortDefinition\",\"toggleSort\"],[[30,0,[\"sortDefinition\"]],[30,0,[\"toggleSort\"]]]]],[30,0,[\"sortedItems\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\",\"component\"]]",
    "moduleName": "media/components/media/table/sortable-columns.hbs",
    "isStrictMode": false
  });

  let SortableColumnsComponent = (_dec = (0, _computed.sort)('args.data', 'sortDefinition'), (_class = (_trackMediaSort = /*#__PURE__*/new WeakSet(), class SortableColumnsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _trackMediaSort);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "segment", _descriptor2, this);

      _initializerDefineProperty(this, "sortAscending", _descriptor3, this);

      _initializerDefineProperty(this, "sortProperty", _descriptor4, this);

      _initializerDefineProperty(this, "sortedItems", _descriptor5, this);
    }

    get sortDefinition() {
      return [`${this.sortProperty}:${this.sortAscending ? 'asc' : 'desc'}`];
    }

    toggleSort(property) {
      _classPrivateMethodGet(this, _trackMediaSort, _trackMediaSort2).call(this, property);

      if (this.sortProperty === property) {
        this.sortAscending = !this.sortAscending;
      } else {
        this.sortAscending = false;
        this.sortProperty = property;
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sortAscending", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sortProperty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'createdTime';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sortedItems", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSort", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSort"), _class.prototype)), _class));
  _exports.default = SortableColumnsComponent;

  function _trackMediaSort2(property) {
    this.segment.track('sorted-by-table-col', {
      group_id: this.args.currentGroup?.id || null,
      col_name: property
    });
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortableColumnsComponent);
});